// Importando bibliotecas e estilos
import React, { useState } from 'react';
import { Button, Modal, Form, Card } from 'react-bootstrap';
import Navbar from '../../components/navbar/navbar.jsx'
import ListaProdutos from '../../components/ListaProduto/listaproduto'
import { CustomSpinner } from '../../components/CustomSpinner'



// Componente principal
function ExportacaoMercadoLivre() {
    const [showModal, setShowModal] = useState(false);
    const [isProductsLoading, setIsProductsLoading] = useState(false)

    const handleExport = () => {
        // Lógica de exportação para o Mercado Livre aqui
        // Utilize a API do Mercado Livre para enviar os dados
        // e realizar a exportação conforme a documentação
        // https://developers.mercadolivre.com.br/pt_br/api-docs-pt-br
        console.log('Exportação para o Mercado Livre realizada com sucesso!');
    };

    return (


        <>
            <Navbar />
            <div className="container-fluid mt-page">

        
                <Button variant="primary" onClick={() => setShowModal(true)}>
                    Exportar para o Mercado Livre
                </Button>

                <Modal show={showModal} onHide={() => setShowModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Exportar para o Mercado Livre</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            {/* Adicione os campos necessários para a exportação */}
                            <Form.Group controlId="formTitulo">
                                <Form.Label>Título do Produto</Form.Label>
                                <Form.Control type="text" placeholder="Digite o título do produto" />
                            </Form.Group>
                            {/* Adicione mais campos conforme necessário */}
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>
                            Fechar
                        </Button>
                        <Button variant="primary" onClick={handleExport}>
                            Exportar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>

        </>
    );
}

export default ExportacaoMercadoLivre;
